var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden","height":"140px"}},[_c('div',{ref:"containerDiv",staticClass:"time-component"},[_c('div',{staticClass:"canvas-container"},[_c('canvas',{ref:"myCanvas",staticClass:"time-canvas",attrs:{"width":_vm.canvasSize,"height":_vm.canvasSize}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }